import { withStyles, Container, CircularProgress } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import styles from "./styles";
import Breadcrumbs from "../../components/Breadcrumbs";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import * as generalActions from "../../actions/general";
import NewsItem from "../../components/NewsItem";
import InfiniteScroll from "react-infinite-scroll-component";
import ReactPlaceholder from "react-placeholder";
import ProjectPlaceholder from "../../components/Home/ProjectComponent/ProjectPlaceholder";

import Seo from "../../components/Seo";

function News(props) {
  const { item, classes, generalActionCreators, news, pages, loading } = props;
  const { fetchNewsById, fetchNews } = generalActionCreators;
  const [page, setPage] = useState(1);

  const seoData = {
    seo_title: "Tin tức cập nhật mới nhất",
    seo_description: "Chúng tôi luôn cập nhất mới nhất về các thông tin công nghệ hàng ngày, phong phú và đa dạng",
    name: "Công ty TNHH thiết kế và lập trình website, app mobile Wasth"
  }

  useEffect(() => {
    if (item) {
      fetchNewsById({ id: item.id, page: 1 });
    } else {
      fetchNews({ page: 1 });
    }
  }, [fetchNewsById, fetchNews, item]);

  const mapParams = () => {
    let params = [{ name: "Tin tức", cate: "news", to: "/tin-tuc" }];

    if (item) {
      params.push({
        name: item.name,
        cate: "news-child",
        to: item.alias
      });
    }

    return params;
  };

  const renderNews = () => {
    if (news && news.length > 0) {
      return news.map(item => (
        <NewsItem newsPage={1} key={item.id} item={item} seoNews={seoData}/>
      ));
    }
  };

  const renderMore = () => {
    if (item) {
      fetchNewsById({ id: item.id, page: page + 1 });
    } else {
      fetchNews({ page: page + 1 });
    }
    setPage(page + 1);
  };

  return (
    <>
      <Seo seoContent={item && item.seo_title !== null ? item : seoData}/>
      <Breadcrumbs params={mapParams()} />
      <Container maxWidth="xl">
        <ReactPlaceholder
          ready={!loading}
          showLoadingAnimation={true}
          customPlaceholder={<ProjectPlaceholder />}
        >
          <div></div>
        </ReactPlaceholder>
        <InfiniteScroll
          className={classes.container}
          dataLength={news.length}
          next={renderMore}
          hasMore={pages > 1 && pages > page - 1 ? true : false}
          loader={
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          }
        >
          {renderNews()}
        </InfiniteScroll>
      </Container>
    </>
  );
}
const mapStateToProps = state => ({
  news: state.general.news,
  pages: state.general.pages,
  loading: state.general.loading,
  currentPage: state.general.currentPage
});

const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalActions, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(News);
